(() => {
  const SELECT = '[data-mj-ring-size-select]';
  const VALUE = '[data-mj-ring-size-value]';
  const SIZER = '[data-mj-ring-sizer]';

  class MjRingSize extends HTMLElement {
    connectedCallback() {
      this.chosen = this.querySelector(SELECT)?.value ?? null;

      this.onChoose = (event) => {
        if (!(event.target instanceof HTMLSelectElement) || !event.target.matches(SELECT)) return;
        this.chosen = event.target.value;
        this.#sync();
      };
      this.onSizer = (event) => {
        if (!(event.target instanceof Element) || !event.target.closest(SIZER)) return;
        this.expanded = true;
        this.#restore();
        const select = this.querySelector(SELECT);
        if (!select) return;
        select.focus();
        try {
          select.showPicker();
        } catch {}
      };
      this.onPageShow = () => {
        this.chosen = this.querySelector(SELECT)?.value ?? this.chosen;
        this.#sync();
      };

      this.onKey = (event) => {
        if (event.key === 'Tab') this.dataset.keyboard = '';
      };
      this.onPointer = () => delete this.dataset.keyboard;

      this.addEventListener('change', this.onChoose);
      this.addEventListener('input', this.onChoose);
      this.addEventListener('click', this.onSizer);
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('keydown', this.onKey, true);
      document.addEventListener('pointerdown', this.onPointer, true);

      this.observer = new MutationObserver(() => this.#restore());
      this.observer.observe(this, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['selected'] });

      this.#sync();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChoose);
      this.removeEventListener('input', this.onChoose);
      this.removeEventListener('click', this.onSizer);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('keydown', this.onKey, true);
      document.removeEventListener('pointerdown', this.onPointer, true);
      this.observer?.disconnect();
    }

    #restore() {
      const select = this.querySelector(SELECT);
      if (!select) return;
      if (this.expanded) this.#expand(select);
      if (this.chosen && select.value !== this.chosen && [...select.options].some((option) => option.value === this.chosen)) {
        select.value = this.chosen;
      }
      this.#sync();
    }

    #expand(select) {
      const sizes = (this.dataset.allSizes ?? '').split(',').filter(Boolean);
      const current = [...select.options].map((option) => option.value);
      if (sizes.length <= current.length || !current.every((size) => sizes.includes(size))) return;
      const value = select.value;
      select.replaceChildren(...sizes.map((size) => new Option(size, size)));
      select.value = value;
    }

    #sync() {
      const select = this.querySelector(SELECT);
      const valueText = this.querySelector(VALUE);
      if (!select || !valueText) return;
      if (valueText.textContent !== select.value) valueText.textContent = select.value;
    }
  }

  if (!customElements.get('mj-ring-size')) customElements.define('mj-ring-size', MjRingSize);
})();
